import React from 'react';

// Poyais One halkası: yükleme göstergesi. Metin yok; ekran okuyucular için gizli etiket var.
// Halka yavaşça döner, hafif altın bir parıltıyla "nefes alır". Hareketi azalt tercihinde dönmez, sadece yumuşakça yanıp söner.
const CSS = `
@keyframes pyRingSpin{to{transform:rotate(360deg)}}
@keyframes pyRingGlow{0%,100%{filter:drop-shadow(0 0 0 rgba(201,168,76,0));opacity:.85}50%{filter:drop-shadow(0 0 10px rgba(201,168,76,.55));opacity:1}}
@keyframes pyRingFade{0%,100%{opacity:.45}50%{opacity:1}}
.py-ring{display:block;animation:pyRingSpin 1.6s cubic-bezier(.55,.1,.35,.9) infinite,pyRingGlow 2.4s ease-in-out infinite}
.py-pageload{display:flex;align-items:center;justify-content:center;min-height:max(240px, calc(100vh - 170px))}
/* Sayfa başlığı (breadcrumb) olan sayfalarda içerik daha aşağıdan başlar: halka yine ekranın ortasında kalsın */
body:has(#poyais-page-header) .py-pageload{min-height:max(240px, calc(100vh - 300px))}
@media (prefers-reduced-motion: reduce){.py-ring{animation:pyRingFade 1.6s ease-in-out infinite}}
`;

export default function PoyaisSpinner({ size = 40, pad = 28, label = 'Yükleniyor' }: { size?: number; pad?: number | string; label?: string }) {
  return (
    <div role="status" aria-live="polite" aria-label={label}
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: pad, width: '100%', boxSizing: 'border-box' }}>
      <style>{CSS}</style>
      <img className="py-ring" src="/poyais-halka.png" alt="" width={size} height={size} draggable={false}/>
      <span style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap' }}>{label}</span>
    </div>
  );
}
